<div class="parent-btn" (clickOutside)="closeMenu()" appClickOutsideComponent>
  <button class="btn global-transition" [ngClass]="{'active' : menuVisible}" (click)="toggleMenuVisible()">
    <nb-icon icon="layout-columns" pack="icomoon" class="icon"></nb-icon>
    <p class="text">{{ 'view_translations.columns_manage' | translate }}</p>
  </button>
  <app-manage-columns-menu class="menu" *ngIf="menuVisible" [detailsLayout]="detailsLayout" (closeMenu)="closeMenu()"> </app-manage-columns-menu>
</div>
